<template>
  <b-overlay
      :show="processing"
      rounded="sm"
  >

    <template v-slot:overlay>
      <div
          v-if="processing"
          class="text-center p-4 bg-primary text-light rounded"
      >
        <b-icon
            icon="cloud-download"
            font-scale="4"
        />
        <div class="mb-3 mt-2">
          منتظر بمانید ...
        </div>
        <b-progress
            min="1"
            max="60"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
        />
      </div>
    </template>
    <b-card
        title="مدیریت پرداخت ها"
    >
      <b-row>
        <b-col
            class="table-size"
        >
          <div class="custom-search">
            <b-row>
              <div class="filter-row">
                <b-button
                    variant="outline-primary"
                    class="mb-1 mr-auto ml-1"
                    v-if="selected.length"
                    @click="showModalMultiple"
                >
                  ویرایش
                </b-button>
                <b-col md="2">
                  <b-form-group
                      label="شماره موبایل یا ایمیل"
                      label-for="Username"
                  >
                    <b-form-input
                        v-model="filterOptions.Username"
                        @keyup.enter="update(1)"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group
                      label="شناسه کاربر"
                      label-for="UserId"
                  >
                    <b-form-input
                        v-model="filterOptions.UserId"
                        @keyup.enter="update(1)"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group
                      label="از تاریخ"
                      label-for="FromDate"
                  >
                    <date-picker
                        v-model="filterOptions.FromDate"
                        placeholder=""
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group
                      label="تا تاریخ"
                      label-for="FromDate"
                  >
                    <date-picker
                        v-model="filterOptions.ToDate"
                        placeholder=""
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group
                      label="وضعیت"
                      label-for="Type"
                  >
                    <v-select
                        v-model="filterOptions.Status"
                        dir="rtl"
                        :reduce="x => x.value"
                        :clearable="true"
                        label="text"
                        :options="enums('UserAffiliateSettlementStatus')"
                    />
                  </b-form-group>
                </b-col>
                <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    class="mb-1 mr-1"
                    variant="warning"
                    @click="update(1)"
                >فیلتر
                </b-button>
                <b-button
                    variant="gradient-secondary"
                    class="mb-1 mr-1"
                    @click="exportExcel()"
                >خروجی اکسل
                </b-button>
              </div>
            </b-row>
          </div>

          <b-table
              bordered
              hover
              striped
              :items="items"
              :fields="fields"
              class="mt-1 mb-2 position-relative"
              responsive
              :busy="loading"
          >
            <template #cell(Id)="data">
              <b-link
                  :to="{ name: 'updateblogcategory', params: { id: data.value }}"
                  class="font-weight-bold"
              >
                #{{ data.value }}
              </b-link>
            </template>

            <template #cell(User)="data">
              <b-link :to="{ name: 'userDetail', params: { id: data.value.Id }}">
                <b-media
                    vertical-align="center"
                    style="align-items: center;"
                >
                  <template #aside>
                    <b-avatar
                        :src="data.value.Image"
                    />
                  </template>
                  <span
                      class="font-weight-bold d-block text-nowrap"
                      style="color: #6e6b7b;"
                  >
                    <template v-if="data.value.Name || data.value.Family">{{ data.value.Name }} {{ data.value.Family }}</template>
                    <template v-else>کاربر زیره</template>
                  </span>
                  <small class="text-muted">{{ data.value.Id }}</small>
                </b-media>
              </b-link>
            </template>

            <template #cell(Status)="data">
              <b-badge
                  :variant="enums('UserAffiliateSettlementStatus', 'value', data.value, 'badge')"
              >
                {{ enums('UserAffiliateSettlementStatus', 'value', data.value, 'text') }}
              </b-badge>
            </template>

            <template #cell(Select)="data">
              <b-form-checkbox
                  @change="changeSelect"
                  v-model="data.item.Select"
                  value="true"
                  style="padding: 0px; width: 18px;"
                  class="custom-control-info"
              >
              </b-form-checkbox>
            </template>

            <template #cell(CreatedAt)="data">
              {{ data.value | date }}
            </template>

            <template #cell(PaidAt)="data">
              {{ data.value | date }}
            </template>

            <template #cell(actions)="data">

              <div
                  class="text-nowrap"
              >
                <b-link @click="showModal(data.item)">
                  <feather-icon
                      :id="`invoice-row-${data.item.Id}-send-icon`"
                      icon="EditIcon"
                      size="16"
                  />
                </b-link>
              </div>
            </template>

            <template #table-busy>
              <div
                  class="text-center my-2"
              >
                <b-spinner
                    variant="primary"
                    class="align-middle"
                />
                <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
              </div>
            </template>

            <template #table-busy>
              <div
                  class="text-center my-2"
              >
                <b-spinner
                    variant="primary"
                    class="align-middle"
                />
                <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
              </div>
            </template>

          </b-table>

          <z-pagination
              :page="filterOptions.Page"
              :total-rows="totalRows"
              :loading="loading"
              @change="update"
          />

        </b-col>

      </b-row>

      <b-modal
          v-model="isShow"
          v-if="isShow"
          ok-title="ذخیره"
          cancel-title="انصراف"
          cancel-variant="outline-secondary"
          centered
          title="ویرایش"
          :no-close-on-backdrop="true"
          size="sm"
          @ok="save"
      >
        <b-row>
          <b-col cols="12">
            <b-form-group
                label="وضعیت"
                label-for="Status">
              <v-select
                  v-model="Status"
                  :options="enums('UserAffiliateSettlementStatus')"
                  dir="rtl"
                  label="text"
                  :clearable="false"
                  :reduce="x => x.value"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
                label="تاریخ"
                label-for="PaidAt">
              <date-picker
                  v-model="PaidAt"
                  placeholder=""
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-modal>
    </b-card>
  </b-overlay>
</template>

<script>
import useraffiliatesettlement from "@/modules/apies/affiliate/useraffiliatesettlement";
import {BIcon} from "bootstrap-vue";

export default {
  name: "UserAffiliateSettlement",
  components: {BIcon},
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        FromDate: this.$moment().startOf('jMonth').format('YYYY/MM/DD'),
        ToDate: this.$moment().endOf('jMonth').format('YYYY/MM/DD'),
        Page: 1,
        Status: null,
        Username: null,
        UserId: null
      },
      isShow: false,
      row: null,
      processing: false,
      counter: 1,
      fields: [
        {
          key: 'Select',
          label: '',
          thClass: 'col-width-10',
        },
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'User',
          label: 'کاربر',
        },
        {
          key: 'Price',
          label: 'مبلغ',
        },
        {
          key: 'CreatedAt',
          label: 'تاریخ درخواست',
        },
        {
          key: 'PaidAt',
          label: 'تاریخ تسویه',
        },
        {
          key: 'Status',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      selected: [],
      Status: 0,
      PaidAt: null,
      Ids: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.useraffiliatesettlement.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.selected = []
            this.loading = false
          })
    },
    copy(code) {
      this.$copyText(code)
      setTimeout(() => {
        this.$root.$emit('bv::hide::tooltip', code)
      }, 1000)
    },
    showModal(row) {
      this.Ids = []
      this.Ids.push(row.Id)
      this.Status = row.Status
      this.PaidAt = row.PaidAt
      this.isShow = true
    },
    showModalMultiple() {
      this.Ids = []
      this.selected.forEach(item => {
        this.Ids.push(item.Id)
      })
      this.Status = 0
      this.PaidAt = null
      this.isShow = true
    },
    save(){
      this.$http.post(this.$api.useraffiliatesettlement.update, {
        Ids: this.Ids,
        Status: this.Status,
        PaidAt:  this.PaidAt
      }).then(() => {
        this.update()
      })
    },
    changeSelect() {
      this.selected = []
      this.items.forEach(item => {
        if (item.Select == 'true'){
          this.selected.push(item)
        }
      })
    },
    exportExcel(){

      var This = this

      This.counter = 1
      This.processing = true

      let interval = setInterval(() => {
        This.counter += 1
      }, 1000)

      let filename = 'UserAffiliateSettlement.xls'
      let xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.onreadystatechange = function() {
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {

          let remaining = 60 - This.counter

          let interval2 = setInterval(() => {
            This.counter += 1
          }, 100)

          setTimeout(() => {

            let a = document.createElement('a')
            a.href = window.URL.createObjectURL(xmlHttpRequest.response)
            a.download = filename
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()

            clearInterval(interval)
            clearInterval(interval2)
            This.processing = false

          },remaining * 100)
        }
      }
      let url = new URL(window.location.origin + '/api/useraffiliatesettlement/excel')
      url.searchParams.set('FromDate', this.$moment(this.filterOptions.FromDate).format('YYYY-MM-DD'));
      url.searchParams.set('ToDate', this.$moment(this.filterOptions.ToDate).format('YYYY-MM-DD'));
      if (this.filterOptions.Status !== null) url.searchParams.set('Status', this.filterOptions.Status);
      xmlHttpRequest.open("GET", url)
      xmlHttpRequest.setRequestHeader('Content-Type', 'application/json')
      xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('accessToken'))
      xmlHttpRequest.responseType = 'blob'
      xmlHttpRequest.send()
    },
  },
}
</script>

<style scoped>

</style>